import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { ROUTES } from '@/routes';
import { LoadingSpinner } from '@/components/LoadingSpinner';

export function PrivateRoute({ children }: { children: ReactNode }) {
  const { session, authLoading } = useAuth();

  if (authLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }
  if (!session) return <Navigate to={ROUTES.WAITLIST} replace />;
  return <>{children}</>;
}
